'use client';

import classNames from 'classnames';
import Button from 'components/gruenland/atoms/button/Button';
import { Container } from 'components/gruenland/atoms/container/Container';
import Link from 'components/gruenland/atoms/link';
import { Reference } from 'types/reference';
import { TasticProps } from '../../types';

interface Props {
  label: string;
  link: Reference;
  align: 'center' | 'left' | 'right';
}

const YggdrasilCtaTastic = ({ data }: TasticProps<Props>) => {
  return (
    <Container>
      <div
        className={classNames({
          'text-center': data.align === 'center',
          'text-left': data.align === 'left',
          'text-right': data.align === 'right',
        })}
      >
        <Link link={data.link}>
          <Button variant="buttonPrimaryGreen">{data.label}</Button>
        </Link>
      </div>
    </Container>
  );
};

export default YggdrasilCtaTastic;
